module.exports = __webpack_public_path__ + "img/dots-logo.6a5e0aea.png";